import { render, staticRenderFns } from "./NewsCardType.vue?vue&type=template&id=6b877b83&scoped=true&"
import script from "./NewsCardType.vue?vue&type=script&lang=js&"
export * from "./NewsCardType.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardType.vue?vue&type=style&index=0&id=6b877b83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b877b83",
  null
  
)

export default component.exports